export const materialTypesEnum = {
    none: 0,
    document: 1,
    video: 2,
    website: 4
}


